import writeExcelFile from "write-excel-file/browser";
import { catLabel, platLabel, outcomeOf, isFresh, hotDaysLeft } from "./constants";

const COLS = [
  ["Business", (l) => l.name], ["Category", (l) => catLabel(l.category)], ["Address", (l) => l.address],
  ["City", (l) => l.city], ["State", (l) => l.state], ["ZIP", (l) => l.zip], ["Phone", (l) => l.phone],
  ["Email", (l) => l.email], ["Website", (l) => l.website], ["Current POS", (l) => l.current_pos],
  ["Owner/Manager", (l) => l.contact_name], ["Title", (l) => l.contact_title], ["Owner phone", (l) => l.contact_phone],
  ["Owner email", (l) => l.contact_email], ["Intent", (l) => l.intent], ["Status", (l) => l.status], ["Outcome", (l) => outcomeOf(l.outcome)?.label], ["Outcome by", (l) => l.outcome_by],
  ["Assigned to", (l, t) => t[l.assigned_to]?.name], ["Follow-up", (l) => l.follow_up_date], ["Notes", (l) => l.notes_count],
  ["Source", (l) => platLabel(l.source_platform)], ["Source URL", (l) => l.source_url], ["Posted", (l) => l.signal_date], ["Date approx.", (l) => (l.signal_date_approx ? "Yes" : "")], ["Date found on", (l) => l.date_note], ["Fresh", (l) => (isFresh(l.signal_date) ? "Yes" : "")], ["Hot days left", (l) => hotDaysLeft(l) ?? ""], ["Signal", (l) => l.signal_quote],
  ["Found", (l) => l.found_at?.slice(0, 10)],
];

const toExcel = async (cols, items, fileName, extra) => {
  const header = cols.map((c) => ({ value: c[0], fontWeight: "bold", backgroundColor: "#E8EEF9" }));
  const rows = items.map((it) => cols.map((c) => {
    const v = c[1](it, extra);
    return v == null || v === "" ? null : typeof v === "number" ? v : String(v);
  }));
  const columns = cols.map((c) => ({ width: Math.min(60, Math.max(12, c[0].length + 4, ...rows.slice(0, 200).map((r) => String(r[cols.indexOf(c)] ?? "").length * 0.9))) }));
  await writeExcelFile([header, ...rows], { columns, stickyRowsCount: 1 }).toFile(fileName);
};

export const exportLeadsCsv = (leads, teamById, label) =>
  toExcel(COLS, leads, `pos-finder-leads-${label}-${new Date().toISOString().slice(0, 10)}.xlsx`, teamById);

const BIG_COLS = [
  ["Group", (g) => g.name], ["Locations", (g) => g.locations], ["Location cities", (g) => (g.location_cities || []).join("; ")],
  ["HQ city", (g) => g.hq_city], ["State", (g) => g.state], ["Website", (g) => g.website], ["Description", (g) => g.description],
  ["Current POS", (g) => g.current_pos], ["Phone", (g) => g.phone], ["Email", (g) => g.email],
  ["Contact", (g) => g.contact_name], ["Title", (g) => g.contact_title], ["Owner phone", (g) => g.contact_phone], ["Owner email", (g) => g.contact_email], ["Source URL", (g) => g.source_url],
  ["In All leads", (g) => (g.lead_id ? "Yes" : "")], ["Found", (g) => g.found_at?.slice(0, 10)],
];

export const exportBigCsv = (groups) => toExcel(BIG_COLS, groups, `pos-finder-big-groups-${new Date().toISOString().slice(0, 10)}.xlsx`);
